const questionsEvaluation0 = new Map([
  [
    "q1",
    {
      question: "Q1",
      options: ["OPT1-Q1", "OPT2-Q1", "OPT3-Q1", "OPT4-Q1"],
      answer: 2,
    },
  ],
  [
    "q2",
    {
      question: "Q2",
      options: ["OPT1-Q2", "OPT2-Q2", "OPT3-Q2", "OPT4-Q2"],
      answer: 0,
    },
  ],
  [
    "q3",
    {
      question: "Q3",
      options: ["OPT1-Q3", "OPT2-Q3", "OPT3-Q3", "OPT4-Q3"],
      answer: 2,
    },
  ],
  [
    "q4",
    {
      question: "Q4",
      options: ["OPT1-Q4", "OPT2-Q4", "OPT3-Q4", "OPT4-Q4"],
      answer: 1,
    },
  ],
  [
    "q5",
    {
      question: "Q5",
      options: ["OPT1-Q5", "OPT2-Q5", "OPT3-Q5", "OPT4-Q5"],
      answer: 3,
    },
  ],
]);

const questionsEvaluation1 = new Map([
  [
    "OPT1",
    {
      question: "Q1",
      options: ["OPT1-Q1", "OPT2-Q1", "OPT3-Q1", "OPT4-Q1"],
      answer: 2,
    },
  ],
  [
    "OPT2",
    {
      question: "Q2",
      options: ["OPT1-Q2", "OPT2-Q2", "OPT3-Q2", "OPT4-Q2"],
      answer: 0,
    },
  ],
  [
    "OPT3",
    {
      question: "Q3",
      options: ["OPT1-Q3", "OPT2-Q3", "OPT3-Q3", "OPT4-Q3"],
      answer: 2,
    },
  ],
  [
    "q4",
    {
      question: "Q4",
      options: ["OPT1-Q4", "OPT2-Q4", "OPT3-Q4", "OPT4-Q4"],
      answer: 1,
    },
  ],
  [
    "q5",
    {
      question: "Q5",
      options: ["OPT1-Q5", "OPT2-Q5", "OPT3-Q5", "OPT4-Q5"],
      answer: 3,
    },
  ],
  [
    "q6",
    {
      question: "Q6",
      options: ["OPT1-Q6", "OPT2-Q6", "OPT3-Q6", "OPT4-Q6"],
      answer: 0,
    },
  ],
]);

export { questionsEvaluation0, questionsEvaluation1 };
